<div class="mat-calendar-footer">
  <button class="btn btn-primary" *ngFor="let range of ranges" (click)="setRange(range.key)">{{ range.label }}</button>
</div>
